import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';
import { PagedData } from '../models/paging/paged-data';
import { Page } from '../models/paging/page';
import { Customer_Type  } from '../models/customer_Type';
import { ServerData } from '../models/paging/server-data';

import { SnotifyService } from 'ng-snotify';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';



@Injectable()
export class CustomerTypeService {
  constructor(private http: HttpClient, private snotifyService: SnotifyService,private authService: AuthService) { }
  
  public getAll(): Promise<Customer_Type[]> {
    const headers = {
      'Content-Type': 'application/json',
    };
    
    return new Promise((resolve, reject) => {
      this.http.get<Customer_Type[]>(environment.apiUrl + 'company/GetAllCustomerTypes', { headers: headers }).subscribe(data => {
        resolve(data);
      }, error => {
        console.log(error);
        resolve(null)
      });
    });
  }

}
